import { required } from "vuelidate/lib/validators";

export default class ListaProdutoData {
  descricao = null;

  status = false;

  produtos = [];

  aplicar_sem_cliente = false;

  constructor({ descricao = null, status = false, produtos = [] }, aplicar_sem_cliente = false) {
    this.descricao = descricao;
    this.status = status;
    this.produtos = produtos;
    this.aplicar_sem_cliente = aplicar_sem_cliente;
  }
}

export const ListaProdutoDataRequired = {
  descricao: {
    required,
  },
};
